import React from 'react';

import PropTypes from 'prop-types';



import { cn } from '@/lib/utils';

const Spinner = ({ className, color }) => (
  <div className={cn("inline-flex justify-center items-center w-12 h-12 max-w-full max-h-full text-primary", className)} style={color ? { color } : {}}>
    <svg viewBox="22 22 44 44" className="w-full h-full animate-spin">
      <circle 
        cx="44" 
        cy="44" 
        r="20.2" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="3.6" 
        strokeDasharray="80, 200"
        strokeDashoffset="0"
        className="opacity-25"
      />
      <circle 
        cx="44" 
        cy="44" 
        r="20.2" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="3.6" 
        strokeDasharray="1, 200"
        strokeDashoffset="0"
        strokeLinecap="round"
        className="opacity-75"
      />
    </svg>
  </div>
);

Spinner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Spinner.defaultProps = {
  className: '',
  color: undefined,
};

export default Spinner;
